import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr",
  "use": "icon-attr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-attr\"><defs><style type=\"text/css\"></style></defs><path d=\"M120.768 457.664h343.264V133.504c0-63.584-50.88-120.8-120.768-120.8H120.768C50.88 12.704 0 69.92 0 133.472v209.792c0 63.552 50.88 114.4 120.768 114.4z m896.288-114.4V133.44c0-63.552-50.88-120.768-120.768-120.768h-222.496c-63.552 0-120.768 50.88-120.768 120.768v330.56h343.264c69.92-6.368 120.768-57.216 120.768-120.768zM680.16 1004.32h228.8c63.584 0 114.432-50.848 114.432-120.768v-209.76c0-63.552-50.848-120.768-120.768-120.768H559.392v330.56c0 63.552 50.848 120.736 120.768 120.736z m-559.36 0h222.464c63.552 0 120.768-50.848 120.768-120.768v-324.16H120.768C57.216 559.36 0 610.24 0 680.16v209.76c0 57.216 50.88 114.4 120.768 114.4z\" p-id=\"4587\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/attr.svg
// module id = YDJn
// module chunks = 58